// Loads the CRATA (Packo) chat widget for the customers that have it on.
// The flag is read from GET /auth/me (v2 only) instead of the JWT: it can be
// switched in the admin while the access token stays the same.
import createAxios from '@/services/axiosHttp';
import { isPickoV2 } from './PickoVersion';

const WIDGET_SRC = 'https://chatbot.sevica.es/widget/packo-widget.js';

let scriptPromise = null;
let isSessionStarted = false;
let isInitialized = false;

function getAccessToken() {
  const user = JSON.parse(localStorage.getItem('user'));
  return user && user.accessToken;
}

function loadScript() {
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = WIDGET_SRC;
      script.async = true;
      script.onload = resolve;
      script.onerror = () => {
        scriptPromise = null;
        reject(new Error(`Could not load ${WIDGET_SRC}`));
      };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

// Called on page load and after the login; once per session.
async function startCrataWidget() {
  if (isSessionStarted || !isPickoV2() || !getAccessToken()) {
    return;
  }
  isSessionStarted = true;

  try {
    const me = await createAxios().get('/auth/me');
    if (!me.customer || !me.customer.is_crata_integration_enabled) {
      return;
    }
    await loadScript();
    // The session may have ended (or the token changed) while /me was in flight.
    const token = getAccessToken();
    if (!isSessionStarted || !token) {
      return;
    }
    window.Packo.init({
      token,
      clientId: me.customer._id,
      usuario: { nombre: '', apellidos: '', email: me.user.email },
    });
    isInitialized = true;
  } catch (error) {
    console.error('Could not start the CRATA widget', error);
  }
}

// Called wherever the session ends, before the stored user is removed.
function stopCrataWidget() {
  if (isInitialized) {
    window.Packo.logout();
  }
  isSessionStarted = false;
  isInitialized = false;
}

function updateCrataWidgetSession(token) {
  if (isInitialized) {
    window.Packo.updateSession({ token });
  }
}

export { startCrataWidget, stopCrataWidget, updateCrataWidgetSession };
